<script>
  import { onMount } from 'svelte';

  let showConsent = false;
  let consented = false;

  onMount(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (consent === null) {
      showConsent = true;
    } else {
      consented = consent === 'true';
    }
  });

  function acceptCookies() {
    localStorage.setItem('cookieConsent', 'true');
    showConsent = false;
    consented = true;
  }
</script>

<style>
  .cookie-consent {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #1a1a1a;
    color: white;
    padding: 1rem;
    z-index: 1000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 -2px 5px rgba(0,0,0,0.2);
  }

  .cookie-text {
    margin: 0 1rem;
    font-size: 0.9rem;
  }

  .buttons {
    display: flex;
    gap: 0.5rem;
  }

  button {
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.9rem;
  }

  .accept {
    background-color: #4CAF50;
    color: white;
  }

  @media (max-width: 600px) {
    .cookie-consent {
      flex-direction: column;
      gap: 1rem;
    }

    .buttons {
      width: 100%;
      justify-content: center;
    }
  }
</style>

{#if showConsent}
  <div class="cookie-consent">
    <p class="cookie-text">
      Данный веб-сайт обрабатывает файлы cookie. Продолжая работу с сайтом, вы соглашаетесь с обработкой файлов cookie вашего браузера.
    </p>
    <div class="buttons">
      <button class="accept" on:click={acceptCookies}>Согласен</button>
    </div>
  </div>
{/if}
